/** @format */
import { AxiosRequestConfig } from 'axios';

import { client } from '@toucan/client/global/axios';
import { MarketCode } from '@toucan/client/global/market';

import { ModelRecommendations } from '@toucan/client/core/recommendations/config/types';

export async function getSimilarModelRecommendations(
    modelIds: number[],
    marketCode: MarketCode
): Promise<ModelRecommendations> {
    const config: AxiosRequestConfig = {
        params: {
            model_ids: modelIds.join(','),
        },
        headers: {
            'X-Market': marketCode,
        },
    };

    const response = await client.get<ModelRecommendations>(
        `/recommendations/similar-models/`,
        config
    );
    return response.data;
}
